export const NATIVE_TOKEN_ADDRESS = '0x0000000000000000000000000000000000000000';
/** minimum CRO value for prelaunch deposit transaction */
export const MIN_AMOUNT_PRELAUNCH_DEPOSIT = 100;
/** minimum LCRO value for prelaunch deposit transaction */
export const MIN_LCRO_AMOUNT_PRELAUNCH_DEPOSIT = 90;
/** minimum ZKCRO value for withdraw transaction */
export const MIN_ZKCRO_AMOUNT_WITHDRAW = 1;
export const ZKCRO_DECIMALS = 18;
export const CRO_DECIMALS_ON_ETHEREUM = 8;
export const LCRO_DECIMALS_ON_ETHEREUM = 8;
export const LCRO_DECIMALS_ON_CRONOS_EVM = 18;
export const CRO_DECIMALS = 8;
export const ETH_DECIMALS = 18;
export const DAI_DECIMALS = 18;
export const YB_TOKEN_DECIMALS = 18;
export const ZK_TOKEN_DECIMALS = 18;
